export const WORKTYPELIST_SEARCH = 'WORKTYPELIST_SEARCH';
export const WORKTYPELIST_PAGE = 'WORKTYPELIST_PAGE';
